define("checkout/components/seamless-checkout/plan-info-modal", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if @isVisible}}
    {{#if this.reviewChangesModalVisible}}
      <SeamlessCheckout::ReviewChangesModal
        @additionalAiCredits={{@additionalAiCredits}}
        @additionalSocialSetCount={{@additionalSocialSetCount}}
        @additionalTeamMemberCount={{@additionalTeamMemberCount}}
        @canApplyDiscount={{@canApplyDiscount}}
        @closeModal={{@closeModal}}
        @currentSubscriptionPlan={{@currentSubscriptionPlan}}
        @didAddCoupon={{@didAddCoupon}}
        @didRemoveDiscount={{@didRemoveDiscount}}
        @discountAmount={{@discountAmount}}
        @hasCheckoutChanges={{@hasCheckoutChanges}}
        @hasExpiringDiscount={{@hasExpiringDiscount}}
        @initialAiCreditsCount={{@initialAiCreditsCount}}
        @initialSocialSetCount={{@initialSocialSetCount}}
        @initialTeamMemberCount={{@initialTeamMemberCount}}
        @isOnLegacyPlan={{@isOnLegacyPlan}}
        @onChangePlan={{@onChangePlan}}
        @openAiCreditsInfo={{this.toggleAiCreditsInfoModal}}
        @openSocialSetInfo={{this.toggleSocialSetInfoModal}}
        @openUserInfo={{this.toggleUserInfoModal}}
        @proration={{@proration}}
        @selectedSubscriptionPlan={{@selectedSubscriptionPlan}}
        data-test-id="review-changes-modal"
      />
    {{else if this.socialSetModalVisible}}
      <Shared::SocialIdentity::Info @handleClose={{this.toggleSocialSetInfoModal}} @showDetails={{true}} />
    {{else if this.userModalVisible}}
      <Shared::User::Info @handleClose={{this.toggleUserInfoModal}} />
    {{else if this.aiCreditsInfoModalVisible}}
      <Shared::AiCredits::Info @handleClose={{this.toggleAiCreditsInfoModal}} />
    {{/if}}
  {{/if}}
  */
  {
    "id": "6sGrRWHd",
    "block": "[[[41,[30,1],[[[41,[30,0,[\"reviewChangesModalVisible\"]],[[[1,\"    \"],[8,[39,1],[[24,\"data-test-id\",\"review-changes-modal\"]],[[\"@additionalAiCredits\",\"@additionalSocialSetCount\",\"@additionalTeamMemberCount\",\"@canApplyDiscount\",\"@closeModal\",\"@currentSubscriptionPlan\",\"@didAddCoupon\",\"@didRemoveDiscount\",\"@discountAmount\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@initialAiCreditsCount\",\"@initialSocialSetCount\",\"@initialTeamMemberCount\",\"@isOnLegacyPlan\",\"@onChangePlan\",\"@openAiCreditsInfo\",\"@openSocialSetInfo\",\"@openUserInfo\",\"@proration\",\"@selectedSubscriptionPlan\"],[[30,2],[30,3],[30,4],[30,5],[30,6],[30,7],[30,8],[30,9],[30,10],[30,11],[30,12],[30,13],[30,14],[30,15],[30,16],[30,17],[30,0,[\"toggleAiCreditsInfoModal\"]],[30,0,[\"toggleSocialSetInfoModal\"]],[30,0,[\"toggleUserInfoModal\"]],[30,18],[30,19]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"socialSetModalVisible\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@handleClose\",\"@showDetails\"],[[30,0,[\"toggleSocialSetInfoModal\"]],true]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"userModalVisible\"]],[[[1,\"    \"],[8,[39,3],null,[[\"@handleClose\"],[[30,0,[\"toggleUserInfoModal\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"aiCreditsInfoModalVisible\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@handleClose\"],[[30,0,[\"toggleAiCreditsInfoModal\"]]]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]]],[]]]],[]],null]],[\"@isVisible\",\"@additionalAiCredits\",\"@additionalSocialSetCount\",\"@additionalTeamMemberCount\",\"@canApplyDiscount\",\"@closeModal\",\"@currentSubscriptionPlan\",\"@didAddCoupon\",\"@didRemoveDiscount\",\"@discountAmount\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@initialAiCreditsCount\",\"@initialSocialSetCount\",\"@initialTeamMemberCount\",\"@isOnLegacyPlan\",\"@onChangePlan\",\"@proration\",\"@selectedSubscriptionPlan\"],false,[\"if\",\"seamless-checkout/review-changes-modal\",\"shared/social-identity/info\",\"shared/user/info\",\"shared/ai-credits/info\"]]",
    "moduleName": "checkout/components/seamless-checkout/plan-info-modal.hbs",
    "isStrictMode": false
  });
  let PlanInfoModalComponent = _exports.default = (_class = class PlanInfoModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "aiCreditsInfoModalVisible", _descriptor, this);
      _initializerDefineProperty(this, "reviewChangesModalVisible", _descriptor2, this);
      _initializerDefineProperty(this, "socialSetModalVisible", _descriptor3, this);
      _initializerDefineProperty(this, "userModalVisible", _descriptor4, this);
    }
    toggleSocialSetInfoModal() {
      this.socialSetModalVisible = !this.socialSetModalVisible;
      this.reviewChangesModalVisible = !this.reviewChangesModalVisible;
    }
    toggleUserInfoModal() {
      this.userModalVisible = !this.userModalVisible;
      this.reviewChangesModalVisible = !this.reviewChangesModalVisible;
    }
    toggleAiCreditsInfoModal() {
      this.aiCreditsInfoModalVisible = !this.aiCreditsInfoModalVisible;
      this.reviewChangesModalVisible = !this.reviewChangesModalVisible;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "aiCreditsInfoModalVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "reviewChangesModalVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "socialSetModalVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userModalVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSocialSetInfoModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSocialSetInfoModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleUserInfoModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleUserInfoModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAiCreditsInfoModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAiCreditsInfoModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanInfoModalComponent);
});